import { request } from '../boot/request.js';
import { getServerBaseURL } from '../utils/base';

const getLoginCaptcha = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    url: '/menu/user/captcha',
    noAddStroreName: true,
    method: 'POST',
    data: params,
  });
};

// 游客登录获取token
const guestLogin = () => request({
    baseURL: getServerBaseURL('permission'),
    url: '/menu/user/guestLogin',
    noAddStroreName: true,
    method: 'GET',
  });

// 无注册登录更新用户信息
const guestBuyerUpdate = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    url: '/menu/user/guestBuyer/update',
    noAddStroreName: true,
    method: 'POST',
    data: params,
  });
};

// 买家登陆后归并当前店铺游客订单
const guestBuyerMerge = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    url: '/menu/user/guestBuyer/merge',
    noAddStroreName: true,
    method: 'POST',
    data: params,
  });
};

const getCaptchaVerify = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    url: '/menu/user/login',
    noAddStroreName: true,
    method: 'POST',
    data: params,
  });
};

const getUserInfo = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    noAddStroreName: true,
    url: '/menu/user/buyer/info',
    method: 'GET',
    params,
  });
};

const updateUserInfo = params => {
  params = params || {};
  return request({
    baseURL: getServerBaseURL('permission'),
    noAddStroreName: true,
    url: '/menu/user/buyer/update',
    method: 'POST',
    data: params,
  });
};

export {
  getLoginCaptcha, getCaptchaVerify, getUserInfo, updateUserInfo, guestLogin, guestBuyerUpdate, guestBuyerMerge
};
